/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const NewAccessDocument = gql`
    mutation NewAccess($accessType: Int!, $email: String!) {
  userAccessNew(accessType: $accessType, email: $email) {
    id
    email
  }
}
    `;
export type NewAccessMutationFn = Apollo.MutationFunction<NewAccessMutation, NewAccessMutationVariables>;

/**
 * __useNewAccessMutation__
 *
 * To run a mutation, you first call `useNewAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newAccessMutation, { data, loading, error }] = useNewAccessMutation({
 *   variables: {
 *      accessType: // value for 'accessType'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useNewAccessMutation(baseOptions?: Apollo.MutationHookOptions<NewAccessMutation, NewAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewAccessMutation, NewAccessMutationVariables>(NewAccessDocument, options);
      }
export type NewAccessMutationHookResult = ReturnType<typeof useNewAccessMutation>;
export type NewAccessMutationResult = Apollo.MutationResult<NewAccessMutation>;
export type NewAccessMutationOptions = Apollo.BaseMutationOptions<NewAccessMutation, NewAccessMutationVariables>;
export const NewAccessByDomainDocument = gql`
    mutation NewAccessByDomain($domainId: Int!, $accessType: Int!, $email: String!) {
  userAccessDomainAccess(
    domainId: $domainId
    accessType: $accessType
    email: $email
  ) {
    id
    email
  }
}
    `;
export type NewAccessByDomainMutationFn = Apollo.MutationFunction<NewAccessByDomainMutation, NewAccessByDomainMutationVariables>;

/**
 * __useNewAccessByDomainMutation__
 *
 * To run a mutation, you first call `useNewAccessByDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewAccessByDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newAccessByDomainMutation, { data, loading, error }] = useNewAccessByDomainMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      accessType: // value for 'accessType'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useNewAccessByDomainMutation(baseOptions?: Apollo.MutationHookOptions<NewAccessByDomainMutation, NewAccessByDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewAccessByDomainMutation, NewAccessByDomainMutationVariables>(NewAccessByDomainDocument, options);
      }
export type NewAccessByDomainMutationHookResult = ReturnType<typeof useNewAccessByDomainMutation>;
export type NewAccessByDomainMutationResult = Apollo.MutationResult<NewAccessByDomainMutation>;
export type NewAccessByDomainMutationOptions = Apollo.BaseMutationOptions<NewAccessByDomainMutation, NewAccessByDomainMutationVariables>;
export const NewAccessByFolderDocument = gql`
    mutation NewAccessByFolder($folderId: Int!, $accessType: Int!, $email: String!) {
  userAccessFolderAccess(
    folderId: $folderId
    accessType: $accessType
    email: $email
  ) {
    id
    email
  }
}
    `;
export type NewAccessByFolderMutationFn = Apollo.MutationFunction<NewAccessByFolderMutation, NewAccessByFolderMutationVariables>;

/**
 * __useNewAccessByFolderMutation__
 *
 * To run a mutation, you first call `useNewAccessByFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewAccessByFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newAccessByFolderMutation, { data, loading, error }] = useNewAccessByFolderMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      accessType: // value for 'accessType'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useNewAccessByFolderMutation(baseOptions?: Apollo.MutationHookOptions<NewAccessByFolderMutation, NewAccessByFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewAccessByFolderMutation, NewAccessByFolderMutationVariables>(NewAccessByFolderDocument, options);
      }
export type NewAccessByFolderMutationHookResult = ReturnType<typeof useNewAccessByFolderMutation>;
export type NewAccessByFolderMutationResult = Apollo.MutationResult<NewAccessByFolderMutation>;
export type NewAccessByFolderMutationOptions = Apollo.BaseMutationOptions<NewAccessByFolderMutation, NewAccessByFolderMutationVariables>;
export const NewAccessByPageDocument = gql`
    mutation NewAccessByPage($pageId: Int!, $accessType: Int!, $email: String!) {
  userAccessPageAccess(pageId: $pageId, accessType: $accessType, email: $email) {
    id
    email
  }
}
    `;
export type NewAccessByPageMutationFn = Apollo.MutationFunction<NewAccessByPageMutation, NewAccessByPageMutationVariables>;

/**
 * __useNewAccessByPageMutation__
 *
 * To run a mutation, you first call `useNewAccessByPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewAccessByPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newAccessByPageMutation, { data, loading, error }] = useNewAccessByPageMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      accessType: // value for 'accessType'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useNewAccessByPageMutation(baseOptions?: Apollo.MutationHookOptions<NewAccessByPageMutation, NewAccessByPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewAccessByPageMutation, NewAccessByPageMutationVariables>(NewAccessByPageDocument, options);
      }
export type NewAccessByPageMutationHookResult = ReturnType<typeof useNewAccessByPageMutation>;
export type NewAccessByPageMutationResult = Apollo.MutationResult<NewAccessByPageMutation>;
export type NewAccessByPageMutationOptions = Apollo.BaseMutationOptions<NewAccessByPageMutation, NewAccessByPageMutationVariables>;
export const AccessTypeChangeDocument = gql`
    mutation accessTypeChange($accessTypes: [GraphUserAccessInput!]!) {
  accessTypeChange(accessTypes: $accessTypes) {
    id
    accessTypes {
      id
      email
      accessType
    }
  }
}
    `;
export type AccessTypeChangeMutationFn = Apollo.MutationFunction<AccessTypeChangeMutation, AccessTypeChangeMutationVariables>;

/**
 * __useAccessTypeChangeMutation__
 *
 * To run a mutation, you first call `useAccessTypeChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccessTypeChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accessTypeChangeMutation, { data, loading, error }] = useAccessTypeChangeMutation({
 *   variables: {
 *      accessTypes: // value for 'accessTypes'
 *   },
 * });
 */
export function useAccessTypeChangeMutation(baseOptions?: Apollo.MutationHookOptions<AccessTypeChangeMutation, AccessTypeChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccessTypeChangeMutation, AccessTypeChangeMutationVariables>(AccessTypeChangeDocument, options);
      }
export type AccessTypeChangeMutationHookResult = ReturnType<typeof useAccessTypeChangeMutation>;
export type AccessTypeChangeMutationResult = Apollo.MutationResult<AccessTypeChangeMutation>;
export type AccessTypeChangeMutationOptions = Apollo.BaseMutationOptions<AccessTypeChangeMutation, AccessTypeChangeMutationVariables>;
export const UserAccessDocument = gql`
    query UserAccess($limit: Int, $page: Int, $search: String) {
  userAccess(
    limit: $limit
    folderWithOutParent: true
    page: $page
    search: $search
  ) {
    userAccessArray {
      domain {
        id
        title
        userAccesses {
          id
          accessType
          user {
            id
            email
          }
        }
        user {
          id
          email
        }
        folders {
          id
          title
        }
      }
      folder {
        id
        title
        url
        domain {
          id
        }
        userAccesses {
          id
          accessType
          user {
            id
            email
          }
        }
        user {
          id
          email
        }
      }
      createdAt
      accessType
    }
    paginator {
      totalPages
      currentPageNumber
      itemNumberPerPage
      totalItemCount
    }
  }
}
    `;

/**
 * __useUserAccessQuery__
 *
 * To run a query within a React component, call `useUserAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAccessQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useUserAccessQuery(baseOptions?: Apollo.QueryHookOptions<UserAccessQuery, UserAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAccessQuery, UserAccessQueryVariables>(UserAccessDocument, options);
      }
export function useUserAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAccessQuery, UserAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAccessQuery, UserAccessQueryVariables>(UserAccessDocument, options);
        }
// @ts-ignore
export function useUserAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserAccessQuery, UserAccessQueryVariables>): Apollo.UseSuspenseQueryResult<UserAccessQuery, UserAccessQueryVariables>;
export function useUserAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserAccessQuery, UserAccessQueryVariables>): Apollo.UseSuspenseQueryResult<UserAccessQuery | undefined, UserAccessQueryVariables>;
export function useUserAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserAccessQuery, UserAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserAccessQuery, UserAccessQueryVariables>(UserAccessDocument, options);
        }
export type UserAccessQueryHookResult = ReturnType<typeof useUserAccessQuery>;
export type UserAccessLazyQueryHookResult = ReturnType<typeof useUserAccessLazyQuery>;
export type UserAccessSuspenseQueryHookResult = ReturnType<typeof useUserAccessSuspenseQuery>;
export type UserAccessQueryResult = Apollo.QueryResult<UserAccessQuery, UserAccessQueryVariables>;
export const SharedDomainsDocument = gql`
    query SharedDomains($page: Int, $limit: Int, $search: String) {
  sharedDomains(page: $page, limit: $limit, search: $search) {
    domains {
      id
      title
      urlType
      domainUrl
      domainCheckStatus
      domainStatus
      errorMessage
      redirectRoute
      userAccesses {
        id
        email
      }
      userDomainAccess {
        accessType
        createdAt
      }
      user {
        id
        email
      }
      accessDomain
      firstPage {
        image
      }
    }
    paginator {
      totalPages
      currentPageNumber
      itemNumberPerPage
      totalItemCount
    }
  }
}
    `;

/**
 * __useSharedDomainsQuery__
 *
 * To run a query within a React component, call `useSharedDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedDomainsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSharedDomainsQuery(baseOptions?: Apollo.QueryHookOptions<SharedDomainsQuery, SharedDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedDomainsQuery, SharedDomainsQueryVariables>(SharedDomainsDocument, options);
      }
export function useSharedDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedDomainsQuery, SharedDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedDomainsQuery, SharedDomainsQueryVariables>(SharedDomainsDocument, options);
        }
// @ts-ignore
export function useSharedDomainsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SharedDomainsQuery, SharedDomainsQueryVariables>): Apollo.UseSuspenseQueryResult<SharedDomainsQuery, SharedDomainsQueryVariables>;
export function useSharedDomainsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedDomainsQuery, SharedDomainsQueryVariables>): Apollo.UseSuspenseQueryResult<SharedDomainsQuery | undefined, SharedDomainsQueryVariables>;
export function useSharedDomainsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedDomainsQuery, SharedDomainsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedDomainsQuery, SharedDomainsQueryVariables>(SharedDomainsDocument, options);
        }
export type SharedDomainsQueryHookResult = ReturnType<typeof useSharedDomainsQuery>;
export type SharedDomainsLazyQueryHookResult = ReturnType<typeof useSharedDomainsLazyQuery>;
export type SharedDomainsSuspenseQueryHookResult = ReturnType<typeof useSharedDomainsSuspenseQuery>;
export type SharedDomainsQueryResult = Apollo.QueryResult<SharedDomainsQuery, SharedDomainsQueryVariables>;
export const SharedFoldersDocument = gql`
    query SharedFolders($page: Int, $limit: Int, $search: String) {
  sharedFolders(page: $page, limit: $limit, search: $search) {
    folders {
      userAccesses {
        id
        email
      }
      userFolderAccess {
        accessType
        createdAt
      }
      domain {
        id
      }
      id
      title
      url
      user {
        id
        email
      }
      accessFolderDomainByPriority
    }
    paginator {
      totalPages
      currentPageNumber
      itemNumberPerPage
      totalItemCount
    }
  }
}
    `;

/**
 * __useSharedFoldersQuery__
 *
 * To run a query within a React component, call `useSharedFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedFoldersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSharedFoldersQuery(baseOptions?: Apollo.QueryHookOptions<SharedFoldersQuery, SharedFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedFoldersQuery, SharedFoldersQueryVariables>(SharedFoldersDocument, options);
      }
export function useSharedFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedFoldersQuery, SharedFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedFoldersQuery, SharedFoldersQueryVariables>(SharedFoldersDocument, options);
        }
// @ts-ignore
export function useSharedFoldersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SharedFoldersQuery, SharedFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<SharedFoldersQuery, SharedFoldersQueryVariables>;
export function useSharedFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedFoldersQuery, SharedFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<SharedFoldersQuery | undefined, SharedFoldersQueryVariables>;
export function useSharedFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedFoldersQuery, SharedFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedFoldersQuery, SharedFoldersQueryVariables>(SharedFoldersDocument, options);
        }
export type SharedFoldersQueryHookResult = ReturnType<typeof useSharedFoldersQuery>;
export type SharedFoldersLazyQueryHookResult = ReturnType<typeof useSharedFoldersLazyQuery>;
export type SharedFoldersSuspenseQueryHookResult = ReturnType<typeof useSharedFoldersSuspenseQuery>;
export type SharedFoldersQueryResult = Apollo.QueryResult<SharedFoldersQuery, SharedFoldersQueryVariables>;
export const SharedPagesDocument = gql`
    query SharedPages($page: Int, $limit: Int, $search: String) {
  sharedPages(page: $page, limit: $limit, search: $search) {
    pages {
      id
      type
      title
      ip
      createdAt
      image
      contentString
      user {
        id
        email
      }
      publishedAt
      block
      script
      accessPageFolderDomainByPriority
      userAccesses {
        id
        email
      }
      userPageAccess {
        accessType
        createdAt
      }
    }
    paginator {
      totalPages
      currentPageNumber
      itemNumberPerPage
      totalItemCount
    }
  }
}
    `;

/**
 * __useSharedPagesQuery__
 *
 * To run a query within a React component, call `useSharedPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedPagesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSharedPagesQuery(baseOptions?: Apollo.QueryHookOptions<SharedPagesQuery, SharedPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedPagesQuery, SharedPagesQueryVariables>(SharedPagesDocument, options);
      }
export function useSharedPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedPagesQuery, SharedPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedPagesQuery, SharedPagesQueryVariables>(SharedPagesDocument, options);
        }
// @ts-ignore
export function useSharedPagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SharedPagesQuery, SharedPagesQueryVariables>): Apollo.UseSuspenseQueryResult<SharedPagesQuery, SharedPagesQueryVariables>;
export function useSharedPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedPagesQuery, SharedPagesQueryVariables>): Apollo.UseSuspenseQueryResult<SharedPagesQuery | undefined, SharedPagesQueryVariables>;
export function useSharedPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedPagesQuery, SharedPagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedPagesQuery, SharedPagesQueryVariables>(SharedPagesDocument, options);
        }
export type SharedPagesQueryHookResult = ReturnType<typeof useSharedPagesQuery>;
export type SharedPagesLazyQueryHookResult = ReturnType<typeof useSharedPagesLazyQuery>;
export type SharedPagesSuspenseQueryHookResult = ReturnType<typeof useSharedPagesSuspenseQuery>;
export type SharedPagesQueryResult = Apollo.QueryResult<SharedPagesQuery, SharedPagesQueryVariables>;
export type NewAccessMutationVariables = Types.Exact<{
  accessType: Types.Scalars['Int']['input'];
  email: Types.Scalars['String']['input'];
}>;


export type NewAccessMutation = { __typename?: 'Mutation', userAccessNew: { __typename?: 'GraphUserAccess', id?: number | null, email?: string | null } };

export type NewAccessByDomainMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  accessType: Types.Scalars['Int']['input'];
  email: Types.Scalars['String']['input'];
}>;


export type NewAccessByDomainMutation = { __typename?: 'Mutation', userAccessDomainAccess?: { __typename?: 'GraphUserAccess', id?: number | null, email?: string | null } | null };

export type NewAccessByFolderMutationVariables = Types.Exact<{
  folderId: Types.Scalars['Int']['input'];
  accessType: Types.Scalars['Int']['input'];
  email: Types.Scalars['String']['input'];
}>;


export type NewAccessByFolderMutation = { __typename?: 'Mutation', userAccessFolderAccess?: { __typename?: 'GraphUserAccess', id?: number | null, email?: string | null } | null };

export type NewAccessByPageMutationVariables = Types.Exact<{
  pageId: Types.Scalars['Int']['input'];
  accessType: Types.Scalars['Int']['input'];
  email: Types.Scalars['String']['input'];
}>;


export type NewAccessByPageMutation = { __typename?: 'Mutation', userAccessPageAccess?: { __typename?: 'GraphUserAccess', id?: number | null, email?: string | null } | null };

export type AccessTypeChangeMutationVariables = Types.Exact<{
  accessTypes: Array<Types.GraphUserAccessInput> | Types.GraphUserAccessInput;
}>;


export type AccessTypeChangeMutation = { __typename?: 'Mutation', accessTypeChange: { __typename?: 'GraphUser', id?: number | null, accessTypes: Array<{ __typename?: 'GraphUserAccess', id?: number | null, email?: string | null, accessType?: number | null }> } };

export type UserAccessQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UserAccessQuery = { __typename?: 'Query', userAccess: { __typename?: 'GraphPathUserAccess', userAccessArray: Array<{ __typename?: 'GraphFolderDomainPage', createdAt?: any | null, accessType?: number | null, domain?: { __typename?: 'GraphDomain', id?: number | null, title?: string | null, userAccesses: Array<{ __typename?: 'UserAccess', id?: number | null, accessType?: number | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }>, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null, folders: Array<{ __typename?: 'GraphFolder', id: number, title: string }> } | null, folder?: { __typename?: 'GraphFolder', id: number, title: string, url?: string | null, domain?: { __typename?: 'GraphDomain', id?: number | null } | null, userAccesses: Array<{ __typename?: 'UserAccess', id?: number | null, accessType?: number | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }>, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null } | null }>, paginator: { __typename?: 'GraphPaginator', totalPages: number, currentPageNumber: number, itemNumberPerPage: number, totalItemCount: number } } };

export type SharedDomainsQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SharedDomainsQuery = { __typename?: 'Query', sharedDomains: { __typename?: 'GraphPathUserSharedDomains', domains: Array<{ __typename?: 'GraphDomain', id?: number | null, title?: string | null, urlType?: number | null, domainUrl?: string | null, domainCheckStatus?: number | null, domainStatus?: string | null, errorMessage?: string | null, redirectRoute?: string | null, accessDomain: number, userAccesses: Array<{ __typename?: 'UserAccess', id?: number | null, email?: string | null }>, userDomainAccess?: { __typename?: 'GraphUserAccess', accessType?: number | null, createdAt?: any | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null, firstPage?: { __typename?: 'GraphPage', image?: string | null } | null }>, paginator: { __typename?: 'GraphPaginator', totalPages: number, currentPageNumber: number, itemNumberPerPage: number, totalItemCount: number } } };

export type SharedFoldersQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SharedFoldersQuery = { __typename?: 'Query', sharedFolders: { __typename?: 'GraphPathUserSharedFolders', folders: Array<{ __typename?: 'GraphFolder', id: number, title: string, url?: string | null, accessFolderDomainByPriority: number, userAccesses: Array<{ __typename?: 'UserAccess', id?: number | null, email?: string | null }>, userFolderAccess?: { __typename?: 'GraphUserAccess', accessType?: number | null, createdAt?: any | null } | null, domain?: { __typename?: 'GraphDomain', id?: number | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }>, paginator: { __typename?: 'GraphPaginator', totalPages: number, currentPageNumber: number, itemNumberPerPage: number, totalItemCount: number } } };

export type SharedPagesQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SharedPagesQuery = { __typename?: 'Query', sharedPages: { __typename?: 'GraphPathUserSharedPages', pages: Array<{ __typename?: 'GraphPage', id?: number | null, type?: number | null, title?: string | null, ip?: string | null, createdAt?: any | null, image?: string | null, contentString: string, publishedAt?: any | null, block: boolean, script?: string | null, accessPageFolderDomainByPriority: number, user: { __typename?: 'User', id?: number | null, email?: string | null }, userAccesses: Array<{ __typename?: 'UserAccess', id?: number | null, email?: string | null }>, userPageAccess?: { __typename?: 'GraphUserAccess', accessType?: number | null, createdAt?: any | null } | null }>, paginator: { __typename?: 'GraphPaginator', totalPages: number, currentPageNumber: number, itemNumberPerPage: number, totalItemCount: number } } };
